import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/my-players/$tag/matchs")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/my-players/$tag/clan-search/results",
      params,
    });
  },
});
